export enum PAYMENT_STATUS_ENUM {
  APPLIED = 'Integrado',
  PENDING = 'Pendiente',
  CANCELLED = 'Cancelado',
  EXCESS = 'Excedente',
  PARTIAL = 'Parcialmente integrado'
}

export enum PAYMENT_STATUS_COLOR_ENUM {
  APPLIED = 'success',
  CANCELLED = 'danger',
  EXCESS = 'info',
  PENDING = 'primary',
  PARTIAL = 'warning'
}
